const Stack = (props: JSX.ElementChildrenAttribute) => {
  return <div className="flex flex-col gap-6">{props.children}</div>;
};

export default Stack;
